import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <div className='flex flex-col items-center justify-center gap-6 p-2 pb-8 text-white'>
        {/* LEGAL LINKS */}
        <div className='flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-center text-[#8f9094]'>
            <Link to='/pricing' className='hover:text-[#2ea759] duration-200'>Pricing</Link>
            <Link to='/privacy-policy' className='hover:text-[#2ea759] duration-200'>Privacy Policy</Link>
            <Link to='/terms-and-conditions' className='hover:text-[#2ea759] duration-200'>Terms &amp; Conditions</Link>
            <Link to='/refund-policy' className='hover:text-[#2ea759] duration-200'>Refund Policy</Link>
            <Link to='/shipping-policy' className='hover:text-[#2ea759] duration-200'>Shipping Policy</Link>
            <Link to='/contact-us' className='hover:text-[#2ea759] duration-200'>Contact Us</Link>
        </div>

        {/* CREDITS */}
        <p className='w-[80%] md:w-[50%] text-lg text-center'>Designed and Developed by <a href='https://github.com/codegoggins' target='_blank' rel='noreferrer' className='text-[#2ea759]'>@codegoggins</a>.
        Built with <span className='text-[#2ea759]'>ReactJS</span> & <span className='text-[#2ea759]'>TailwindCSS</span>. Hosted on <span className='text-[#2ea759]'>Netlify</span>.</p>
    </div>
  )
}

export default Footer
